/**
 * 버튼 (DESIGN_SPEC 6장). 높이 48, 반경 16.
 *
 * - primary: --color-brand 채움
 * - secondary: 1px --color-brand 외곽선
 * - text: 글자 버튼
 *
 * 상태: 기본, 눌림, 비활성(40%), 처리 중(busy). 처리 중에는 다시 눌리지 않습니다.
 */
import { LoaderCircle } from 'lucide-react';

const VARIANT_CLASSES = {
    primary: 'bg-brand text-on-brand',
    secondary: 'border border-brand bg-surface text-brand',
    text: 'bg-transparent text-brand',
};

const SIZE_CLASSES = {
    lg: 'h-12 px-5 text-[15px]',
    md: 'h-11 px-5 text-label',
    sm: 'h-10 px-4 text-label',
};

export function Button({
    variant = 'primary',
    size = 'lg',
    fullWidth = false,
    busy = false,
    disabled = false,
    type = 'button',
    className = '',
    children,
    ...rest
}) {
    const isDisabled = disabled || busy;
    return (
        <button
            type={type}
            disabled={isDisabled}
            aria-busy={busy || undefined}
            className={`inline-flex items-center justify-center gap-2 rounded-card font-semibold transition-opacity active:opacity-80 disabled:opacity-40 ${
                VARIANT_CLASSES[variant]
            } ${SIZE_CLASSES[size]} ${fullWidth ? 'w-full' : ''} ${className}`}
            {...rest}
        >
            {busy ? <LoaderCircle size={18} strokeWidth={1.6} className="animate-spin" aria-hidden="true" /> : null}
            {children}
        </button>
    );
}
